import { Group, Text } from "react-konva";
import { usePlacementZoomAndPan } from "../hooks/usePlacementZoomAndPan";
import { TextLabel } from "./SizeLabel";

export type NecklineMeasurementProps = {
  /** X coordinate of the center line (already scaled) */
  centerX: number;
  /** Y coordinate of the neckline reference line (already scaled) */
  necklineY: number;
  /** Horizontal offset for the measurement text (positive/negative, already scaled) */
  textOffset: number;
  /** Horizontal offset for the size label (positive/negative, already scaled) */
  sizeOffset: number;
  /** Measurement text, e.g. '3" - 4"' */
  measurementText: string;
  /** Size label, e.g. 'XS-XL' */
  sizeLabel: string;
  /** Color for the plain text */
  plainTextFill: string;
  /** Background fill for the size label */
  backgroundFill: string;
  /** Text color inside the size label */
  backgroundTextFill: string;
};

const FONT_SIZE = 12;
const MEASUREMENT_TEXT_OFFSET = 25;

export function NecklineMeasurement({
  centerX,
  necklineY,
  textOffset,
  sizeOffset,
  measurementText,
  sizeLabel,
  plainTextFill,
  backgroundFill,
  backgroundTextFill
}: NecklineMeasurementProps) {
  const { zoom } = usePlacementZoomAndPan();

  return (
    <Group>
      {/* Plain measurement text */}
      <Text
        x={centerX + textOffset}
        y={necklineY - MEASUREMENT_TEXT_OFFSET / zoom}
        text={measurementText}
        fontSize={FONT_SIZE}
        fontStyle="700"
        fill={plainTextFill}
        scaleX={1 / zoom}
        scaleY={1 / zoom}
      />

      {/* Size label */}
      <TextLabel
        x={centerX + sizeOffset}
        y={necklineY}
        tagFill={backgroundFill}
        textFill={backgroundTextFill}
      >
        {sizeLabel}
      </TextLabel>
    </Group>
  );
}
